export interface Branch {
    location: string;
    latitude: number;
    longitude: number;
    name: string;
    phone: string;
    address: string;
    contactPerson: string;
    email: string;
    website: string;
    websiteName: string
}

export interface Province {
    title: string;
    branches: Branch[];
    active: boolean;
}

export const Branches: Province[] = [
    {
        title: 'Eastern Cape',
        branches: [
            {
                location: 'East London',
                latitude: -33.01774610504712,
                longitude: 27.90578098236524,
                name: 'Flight Specials East London',
                phone: '043 726 5327',
                address: '',
                contactPerson: '',
                email: 'laurette@aloetravel.co.za',
                website: 'https://aloetravel.co.za/',
                websiteName: 'XL Aloe Travel'
            },
            {
                location: 'Humansdorp',
                latitude: -34.027911256330285,
                longitude: 24.78028368332192,
                name: 'Flight Specials Aquila Travel Humansdorp',
                phone: '082 390 3700 / 079 494 9341',
                address: 'House 52, 52 Voortrekker Road, Humansdorp 6300',
                contactPerson: 'Delia Davie / Elmo Hamilton',
                email: 'delia@aquiltravel.co.za / elmo@aquilatravel.co.za',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'XL Flight Specials'
            },
            {
                location: 'King Williams Town',
                latitude: -32.87349103926787,
                longitude: 27.391473646832825,
                name: 'Flight Specials Willards Travel',
                phone: '043 642 1588 / 082 320 0199',
                address: '',
                contactPerson: 'Juan Bedser',
                email: 'juan@willardstravel.co.za',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'XL Flight Specials'
            },
            {
                location: 'Mthatha',
                latitude: -31.590828713568943,
                longitude: 28.757264299861284,
                name: 'Flight Specials - Click n Travel',
                phone: '047 531 4021',
                address: '31 Flamingo Drive, Southernwood, Mthata 5100',
                contactPerson: 'Sazi Mhlahlo',
                email: 'sazim@clickntravel.co.za',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'XL Flight Specials'
            }
        ],
        active: false
    },
    {
        title: 'Free State',
        branches: [
            {
                location: 'Bloemfontein',
                latitude: -29.090750867563866,
                longitude: 26.23893656779947,
                name: 'Flight Specials Bloemfontein',
                phone: '083 284 5397',
                address: '48 Waverley Road, Waverley, Bloemfontein',
                contactPerson: 'Ilsè Diedericks',
                email: 'ilse@flightspecials.co.za',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'XL Flight Specials'
            },
            {
                location: 'Welkom',
                latitude: -27.98361058969424,
                longitude: 26.748624183101168,
                name: 'Flight Specials Welkom',
                phone: '057 352 2202 / 082 552 8201',
                address: '377 Stateway, Doom, Welkom, 9459',
                contactPerson: 'Fernando Linder-Haber',
                email: 'nanda@flightspecials.co.za',
                website: 'https://www.facebook.com/profile.php?id=61555047608013',
                websiteName: 'Facebook'
            }
        ],
        active: false
    },
    {
        title: 'Gauteng',
        branches: [
            {
                location: 'Bedfordview',
                latitude: -26.168477765278155,
                longitude: 28.15671351003225,
                name: 'Flight Specials Bedfordview',
                phone: '076 431 0594',
                address: 'Unit 9 Air-Tec House, Eastwood Office Park, 118 Riley Road, Bedfordview',
                contactPerson: 'Gail Louw',
                email: 'gail@flightspecialsbedfordview.co.za',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'XL Flight Specials'
            },
            {
                location: 'Centurion',
                latitude: -25.881184527967008,
                longitude: 28.18209693885788,
                name: 'Flight Specials Centurion Southlake inculding Fusion Travel',
                phone: '012 663 6565 / 087 095 1000 / 083 635 7435',
                address: '14 Stanford Office Park, 12 Bauhinia Ave, Highveld Techno Park, Centurion',
                contactPerson: 'Lenor Botma',
                email: 'lenor@southlake.co.za',
                website: 'https://fusiontravel.co.za/',
                websiteName: 'Fusion'
            },
            {
                location: 'Greenside',
                latitude: -26.157030845437806,
                longitude: 28.01181866770147,
                name: 'Flight Specials Modi\'s Travel',
                phone: '011 838 5208 / 083 675 6805',
                address: '206 Barry Hertzog Ave, Greenside, Johannesburg, 2193',
                contactPerson: 'Jaiprakash Bhula',
                email: 'jay.bhula@modistravel.co.za',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'XL Flight Specials'
            },
            {
                location: 'Johannesburg',
                latitude: -26.17359565860244,
                longitude: 28.01838854858625,
                name: 'Flight Specials - XL Kimzan Travel',
                phone: '011 726 2180 / 082 452 1316',
                address: '22 Lawrence Road, Westcliff 2193',
                contactPerson: '',
                email: 'claudia@hwtkimzan.co.za',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'XL Flight Specials'
            },
            {
                location: 'Johannesburg',
                latitude: -26.109048562361117,
                longitude: 27.940126883039547,
                name: 'Flight Specials - KLS Corporate Travel Solutions',
                phone: '010 541 1849',
                address: '224 Dale Lace Ave, Randpark Ridge, Johannesburg, 2169',
                contactPerson: 'Karen Strydom',
                email: 'karen@klscorporatetravel.com',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'XL Flight Specials - Corporate Travel'
            },
            {
                location: 'Northcliff',
                latitude: -26.136120404608377,
                longitude: 27.97499712537064,
                name: 'Flight Specials World Travel Northcliff',
                phone: '011 888 8322 / 083 725 7886',
                address: 'Shop 8 Palala Shopping Center, cnr Beyers Naude Dr, 283 Lewisham Rd, Northcliff, 2195',
                contactPerson: 'Belinda Magua',
                email: 'belinda@worldtravel.org.za',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'XL Flight Specials'
            },
            {
                location: 'Pretoria',
                latitude: -25.771209796347343,
                longitude: 28.232435410019544,
                name: 'Flight Specials Blue Cloud Travel',
                phone: '087 830 7881 / 087 830 7882',
                address: '269 Veale Street, Nieuw Muckleneuk, Pretoria, 0181',
                contactPerson: 'Amukelani Khoza / Danielle Gordon',
                email: 'amukelani@bluecloudinvestments.co.za / danielle.gordon@mjdholdings.co.za',
                website: 'https://www.bluecloudtravel.co.za/',
                websiteName: 'Blue Cloud Travel Solutions'
            },
            {
                location: 'Pretoria',
                latitude: -25.811505167201588,
                longitude: 28.09285079652541,
                name: 'Flight Specials TravelDepot',
                phone: '012 370 4725',
                address: '369 Willem Eramus Street, Erasmia, 0183',
                contactPerson: 'Moaaza Abdoola',
                email: 'moaaza@traveldepot.co.za',
                website: 'https://traveldepot.co.za/',
                websiteName: 'Travel Depot'
            },
            {
                location: 'Pretoria',
                latitude: -25.749883350055697,
                longitude: 28.216282763842358,
                name: 'Flight Specials Pretoria',
                phone: '012 343 9120 / 083 259 8497 / 084 565 3392',
                address: '723 Park Street, Sunnyside, Pretoria',
                contactPerson: 'Pieter Smith Alet Estelle Smith',
                email: 'pietersmith@pretoriatravel.co.za / estelle@pretoriatravel.co.za',
                website: 'https://www.pretoriatravel.co.za/',
                websiteName: 'Pretoria Travel'
            },
            {
                location: 'Rivonia',
                latitude: -26.080546358589068,
                longitude: 28.032162510029412,
                name: 'Flight Specials Axios Travel',
                phone: '011 234 0999 / 083 269 2877 / 083 260 1235',
                address: '9 Kingswood Crescent, River Club, Sandton',
                contactPerson: 'Doris Vlachakis / Stelios Vlachakis',
                email: 'doris@axiostravel.co.za / stelios@axiostravel.co.za',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'XL Flight Specials'
            },
            {
                location: 'Bedfordview',
                latitude: -26.16611134347331,
                longitude: 28.14105474858487,
                name: 'Optima Vibe Travel',
                phone: '083 378 3900 / 076 736 5603',
                address: '1 Hingham Field, 79A Boeing Road East, Bedfordview, 2007',
                contactPerson: 'Anneke Geldenhuys / Carol-Ann Field',
                email: 'anneke.geldenhuys@optimavibe.co.za / carol-ann.field@optimavibe.co.za',
                website: 'https://optimavibe.co.za/',
                websiteName: 'Optima Vibe'
            },
            {
                location: 'Radiokop',
                latitude: -26.106460257883676,
                longitude: 27.90963853886513,
                name: 'Flight Specials Corporate Leader Travel',
                phone: '082 312 5973',
                address: '4 Rundu, Maritz Cose, Radiokop, Gauteng, 1725',
                contactPerson: 'Kurt Bäuerle-sims / Naomi Mortje',
                email: 'kurt@cl-travel.com / Naomi@cl-travel.com',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'XL Flight Specials - Corporate Leader Travel'
            },
            {
                location: 'Sandton',
                latitude: -26.132129139677364,
                longitude: 28.046460290908275,
                name: 'Flight Specials - The Travel Department',
                phone: '011 770 6945',
                address: '15 Fricker Road, Illovo Boulevard, Sandton, 2196',
                contactPerson: 'Lisa Zlotnick',
                email: 'lisa@thetraveldepartment.co.za',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'Flight Specials - The Travel Department'
            }
        ],
        active: false
    },
    {
        title: 'Limpopo',
        branches: [
            {
                location: 'Polokwane',
                latitude: -23.891352211538443,
                longitude: 29.450416403648415,
                name: 'Flight Specials Boledi Travel Center',
                phone: '082 802 1329',
                address: 'Shop no 65, Polokwane',
                contactPerson: 'Raessah Boledi Hassim',
                email: 'boleditravel@telkomsa.net',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'XL Flight Specials'
            }
        ],
        active: false
    },
    {
        title: 'Mpumalanga',
        branches: [
            {
                location: 'Middelburg',
                latitude: -25.766908141695303,
                longitude: 29.46346447010076,
                name: 'Flight Specials Middelburg',
                phone: '013 244 1232 / 086 682 9203',
                address: '',
                contactPerson: '',
                email: 'riethal@flightspecials.co.za',
                website: 'www.budgetislandholidays.co.za',
                websiteName: 'Budget Island Holidays'
            },
            {
                location: 'Witbank',
                latitude: -25.907014217833943,
                longitude: 29.267740111867983,
                name: 'Flight Specials Witbank',
                phone: '013 692 4841 / 082 457 1954 / 072 564 8737',
                address: '8 Gemini Street, 3 Gemini Gardens, Reyno Ridge, Witbank, 1035',
                contactPerson: 'Rietha Labuschagne / Le-Ann Smallberger',
                email: 'riethal@flightspecials.co.za / leannl@flightspecials.co.za',
                website: 'www.budgetislandholidays.co.za',
                websiteName: 'Budget Island Holidays'
            }
        ],
        active: false
    },
    {
        title: 'North West',
        branches: [
            {
                location: 'Klerksdorp',
                latitude: -26.848326062913767,
                longitude: 26.673886128397783,
                name: 'Flight Specials Klerksdorp',
                phone: '082 784 3459',
                address: 'Shop 3, Times Square Flamwood, Klerksdorp, 2570',
                contactPerson: 'Farzana Moosa',
                email: 'fazmoosa@icloud.com',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'XL Flight Specials'
            }
        ],
        active: false
    },
    {
        title: 'Kwa-Zulu Natal',
        branches: [
            {
                location: 'Queensburgh',
                latitude: -29.869643008577217,
                longitude: 30.89561852570891,
                name: 'Flight Specials Queensburgh',
                phone: '086 087 2835',
                address: '',
                contactPerson: '',
                email: 'brenda@coctravel.co.za',
                website: 'https://www.cityofchoicetravel.com/',
                websiteName: 'City of Choice Travel & Tours'
            },
            {
                location: 'Westville',
                latitude: -29.839907328118237,
                longitude: 30.910859725495502,
                name: 'Flight Specials Westville',
                phone: '031 109 099 / 082 921 6045',
                address: '9 Stedman Mews, 128 Jan Hofmeyer Road, Westville, 3630',
                contactPerson: 'Kim van den Berg',
                email: 'kim@xlfsdbn.co.za',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'XL Flight Specials'
            },
        ],
        active: false
    },
    {
        title: 'Western Cape',
        branches: [
            {
                location: 'Cape Town',
                latitude: -33.89055195838927,
                longitude: 18.51721068331658,
                name: 'Flight Specials Jetstream Travel (Pty) Ltd',
                phone: '021 023 0180 / 082 789 8829 / 083 391 3760',
                address: 'Suite SL204(A), Boulevard Place, cnr Heron Crescent & Century Blvd, Century City, Cape Town',
                contactPerson: 'Stefan Lowe / Chyrisse Swan',
                email: 'stefan@jetstravel.co.za / chyrisse@jetstravel.co.za',
                website: 'https://www.jetstravel.co.za/',
                websiteName: 'Jetstream Travel'
            },
            {
                location: 'George',
                latitude: -34.12007480970772,
                longitude: 18.839061665707405,
                name: 'Flight Specials George',
                phone: '044 873 2829 / 084 513 0575',
                address: '43 George',
                contactPerson: 'Elize van der Merwe',
                email: 'elize@flightspecials.co.za',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'Flight Specials George'
            },    
            {
                location: 'Hermanus',
                latitude: -34.40466793351226,
                longitude: 19.269028848943638,
                name: 'Flight Specials Hermanus',
                phone: '028 312 3702 / 028 312 2516',
                address: '',
                contactPerson: '',
                email: 'glenda@flightspecials.co.za',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'Flight Specials Hermanus'
            },
            {
                location: 'Knysna',
                latitude: -34.05291717016429,
                longitude: 23.078047410313744,
                name: 'Flight Specials Knysna',
                phone: '083 395 1873 / 082 043 4579',
                address: '16 Forest Gardens, Hunters Home, Knysna, 6571',
                contactPerson: 'Wendy Adendorff / Debbie Matzner',
                email: 'wendy@fsknysna.co.za',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'Flight Specials Knysna'
            },
            {
                location: 'Mosselbay',
                latitude: -34.17780325255539,
                longitude: 22.12495345313382,
                name: 'Flight Specials Murex Travel',
                phone: '044 690 4148 / 082 694 4869',
                address: 'Bayview Center, Shop 15 C/N Marsh Street & Alhof Drive DA Nova, Mossel Bay',
                contactPerson: 'Peter Hansen',
                email: 'peter@murextravel.co.za',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'Flight Specials'
            },
            {
                location: 'Parklands',
                latitude: -33.81255043343902,
                longitude: 18.50023794286082,
                name: 'Flight Specials Andgo.com',
                phone: '021 556 5884 / 084 554 3246',
                address: '',
                contactPerson: 'Robbert Sneddon',
                email: 'robert@andgo.com',
                website: 'www.andgo.com',
                websiteName: 'Andgo'
            },
            {
                location: 'Stellenbosch',
                latitude: -33.93240784478054,
                longitude: 18.86559585448336,
                name: 'Flight Specials Neelsie travel',
                phone: '021 883 9898 / 083 255 0709 / 078 414 2698',
                address: 'CJ Laneghoven Student Center, Shop G41, 7 De Beer Street, Stellenbosch',
                contactPerson: 'Hannetjie Claasen / Craig Claasen',
                email: 'hannetjie@neelsietravel.co.za / craig@neelsietravel.co.za',
                website: 'www.neelsietravel.co.za',
                websiteName: 'Neelsie Travel'
            }
        ],
        active: false
    },
    {
        title: 'Zimbabwe',
        branches: [
            {
                location: 'Harare',
                latitude: -17.793656886806026,
                longitude: 31.046608682808465,
                name: 'Flight Specials - Skylark Travel and Tours',
                phone: '+263 24 279 6286 / +263 24 279 6287',
                address: '21 Shamwari CPX, Maasdorp Ave, Belgravia, Harare',
                contactPerson: 'Katija da Silva Marques',
                email: 'katija@skylarktravel.net',
                website: 'https://www.flightspecials.co.za/',
                websiteName: 'Flight Specials'
            }
        ],
        active: false
    },
]